import React from 'react';

export const TeamCards: React.StatelessComponent = ({ children, ...props }) => (
  <div {...props}>
    <div>{'<TeamCards>'}</div>
    {/* TMON-889 Use header tab components */}
    <div>Header tabs here</div>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards.tsx